import Analytics from 'analytics';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import googleTagManager from '@analytics/google-tag-manager';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { isRealProduction } from 'Douleutaras/constants/system';
const countryCode = useLocalization().countryCode;

const plugins = [];

// Only enable plugins on production
if (isRealProduction) {
  plugins.push(
    googleTagManager({
      containerId: COUNTRY_CONFIG.GTM_CONTAINER_ID[countryCode] // GTM is initialized based on country id
    })
  );
}

export const analytics = Analytics({
  app: 'Douleutaras react',
  version: '1.0',
  plugins,
  debug: process.env.GTM_ENABLE_DEVELOPMENT_DEBUG === '1' || !isRealProduction
});

export default analytics;
